import { defineComponentStyle } from "@/components/ui"

export const vStackStyle = defineComponentStyle({
  base: {
    alignItems: "stretch",
    width: "full",
  },
})

export type VStackStyle = typeof vStackStyle
